module.exports = __webpack_public_path__ + "static/media/handelsblatt.3017578d.png";